import { Button, Grid } from '@material-ui/core';
import { Pagination, useRouter } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal, { default as ModalStep } from 'components/Modal';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useState } from 'react';

import NewTeams from './NewTeams';
import TeamsCard from './TeamsCard';

const Result = ({
  onPaginationChange,
  page,
  refetch,
  teams,
  totalElements,
  addStudent,
}) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { push } = useRouter();

  const [openCreateClasses, setOpenCreateClasses] = useState(false);

  const goToListInviteStudent = () => {
    push(ROUTES_PATH.BUSINESS_INVITE_STUDENT);
  };

  const handleOpenCreateClasses = () => {
    setOpenCreateClasses(true);
  };

  const handleCloseCreateClasses = () => {
    setOpenCreateClasses(false);
  };

  return (
    <div className={classes.container}>
      {teams.length > 0 ? (
        <Grid container className={classes.teamsDiv}>
          {teams.map(({ id, label }, index) => (
            <TeamsCard
              key={index}
              id={id}
              label={label}
              refetch={refetch}
              addStudent={addStudent}
            />
          ))}
        </Grid>
      ) : (
        <Grid
          container
          style={{
            marginTop: spacing(2.5),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Grid
            item
            xs={12}
            className={css({
              display: 'flex',
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#F3F7FF',
              borderRadius: 12,
              '@media screen and (max-width: 768px)': {
                padding: 20,
              },
            })}
          >
            <Grid
              item
              className={css({
                backgroundColor: '#FFFFFF',
                borderRadius: 12,
                padding: '30.0px',
                '@media screen and (max-width: 768px)': {
                  padding: '20px',
                },
              })}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <h1 style={{ margin: '0px 0px 30px 0px' }} className={global.title}>
                  {' '}
                  Commencez à construire des équipes
                </h1>
                <p style={{ textAlign: 'center', margin: '5px' }} className={global.infoText}>
                  {' '}
                  1 . Organisez simplement vos équipes.
                </p>
                <p style={{ textAlign: 'center', margin: '5px' }} className={global.infoText}>
                  {' '}
                  2 . Invitez vos apprenants externes ou internes à la solution.
                </p>
                <p style={{ textAlign: 'center', margin: '5px 5px 30px 5px' }} className={global.infoText}>
                  {' '}
                  3. Maintenez un suivi tripartite tout le long de la formation (contrats, planning et messagerie).
                </p>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleOpenCreateClasses}
                  disableElevation
                >
                  Créer une équipe
                </Button>
              </div>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Pagination
        onChange={onPaginationChange}
        page={page}
        pageCount={12}
        totalCount={totalElements}
      />
      <Modal
        nbStep={1}
        onCancel={handleCloseCreateClasses}
        open={openCreateClasses}
        step={1}
        title="Formulaire de création d’équipe"
        subTitle="Créez votre équipe et inviter des étudiants à rejoindre votre équipe depuis différentes manières (Depuis votre équipe ou d’une affiliation)"
        withStep={false}
      >
        <NewTeams close={handleCloseCreateClasses} refetch={refetch} />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background: 'white',
    borderRadius: "0px 0px 10px 10px",
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonDiv: {
    width: '100%',
  },
  teamsDiv: {
    marginTop: spacing(2.5),
    backgroundColor: '#F3F7FF',
    padding: spacing(1.25),
    borderRadius: 36,
    width: '100%',
  },
  noResults: {
    marginTop: spacing(2.5),
    padding: spacing(2),
    backgroundColor: '#F3F7FF',
    borderRadius: 36,
    width: '100%',
    textAlign: 'center',
    color: '#999',
  },
});

Result.propTypes = {
  teams: PropTypes.array,
  onPaginationChange: PropTypes.func,
  page: PropTypes.number,
  totalElements: PropTypes.number,
  refetch: PropTypes.func,
};

export default Result;
